export * from './module';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/map/index.ts